/**
 * Auth Callback Page
 * Landing page after successful authentication from Python backend
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuth, isLoading, isAuthenticated } = useAuth();

  useEffect(() => {
    // Revalidate session after auth redirect
    const validateSession = async () => {
      await checkAuth();
    };

    validateSession();
  }, []);

  useEffect(() => {
    // Once auth is confirmed, redirect to dashboard
    if (!isLoading && isAuthenticated) {
      // TODO: Check if onboarding is complete
      // If onboarding not complete, go to /onboarding
      // Otherwise go to /dashboard
      navigate('/dashboard', { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-light">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mb-4"></div>
        <h2 className="text-xl font-semibold text-text-main mb-2">
          Completing sign in...
        </h2>
        <p className="text-text-muted">
          Please wait while we set up your session
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;

